import React, { Component, ErrorInfo, ReactNode } from "react";
import { DefaultButton } from "../button/defaultButton/DefaultButton";
import styles from "./ErrorPage.module.scss";
import { logFrontendError } from "../../infrastructure/utilities/errorLoggingUtility";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);

    // Send error to backend for logging
    logFrontendError(error, errorInfo);
  }

  private handleRefresh = () => {
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div className={styles.root}>
          <h2>Възникна неочаквана грешка</h2>
          <p className={styles.root_secondary}>
            Нещо се обърка. Моля, опитайте да презаредите страницата или се
            свържете с поддръжката.
          </p>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <DefaultButton
              className={styles.root_button}
              label="Презареди страницата"
              onClick={this.handleRefresh}
            />
          </div>
          {import.meta.env.VITE_ENVIRONMENT === "Local" &&
            this.state.error && (
              <details
                style={{
                  marginTop: "2rem",
                  textAlign: "left",
                  maxWidth: "80%",
                }}
              >
                <summary style={{ cursor: "pointer", marginBottom: "1rem" }}>
                  Техническа информация (само за разработчици)
                </summary>
                <pre
                  style={{
                    backgroundColor: "#f5f5f5",
                    padding: "1rem",
                    borderRadius: "4px",
                    overflow: "auto",
                    color: "#333",
                    fontSize: "0.8rem",
                  }}
                >
                  {this.state.error.stack}
                </pre>
              </details>
            )}
        </div>
      );
    }

    return this.props.children;
  }
}
